// The Scene workspace's one composed façade panel.
//
// Environment was registered as three independent dockview panels
// (`environment.presets` in the left zone, `environment.preview` in the
// centre, `environment.properties` in the right zone). Because dockview
// zones belong to the *preset*, not to the tab on screen, that put
// Environment's own preset list and sliders permanently either side of
// Edit and Map Builder too - two panels that already render their own
// scene tree and inspector internally. The result was a five-column Scene
// workspace in which the viewport, the one thing every reference editor
// gives the most room to, measured 538px of a 1600px window (34%), with
// Environment's controls flanking a scene they had nothing to say about.
//
// This is the same fix Systems already had (systemsPanels.tsx): compose the
// three existing panel bodies into one fixed flex layout and register that
// as a single zone-less panel, so Scene's tab strip is Edit / Map Builder /
// Environment and each tab owns the full width. None of the three panel
// components' internals change - they already read and write the shared
// environment slice rather than local state, so composing them here is
// purely a layout change.
import {
  EnvironmentPresetsPanel,
  EnvironmentPreviewPanel,
  EnvironmentPropertiesPanel,
} from './editor-modes3';

export function SceneEnvironmentPanel({ projection }: { projection?: '2D' | '3D' }) {
  return (
    <div style={{ display: 'flex', flex: 1, minWidth: 0, minHeight: 0 }}>
      <EnvironmentPresetsPanel />
      <EnvironmentPreviewPanel projection={projection} />
      <EnvironmentPropertiesPanel projection={projection} />
    </div>
  );
}
